import React, { useContext } from 'react'
import { Grid, Typography } from '@mui/material'
import { ApplicationContext } from './LoanApplication'
import moment from 'moment'

const Official = () => {

  const applicationDetails = useContext(ApplicationContext)

  // const jsonString = applicationDetails.companyInfo.location;
  // const jsonObject = JSON.parse(jsonString);
  // console.log(jsonObject);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={5}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            Company Name:
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            {applicationDetails && applicationDetails.companyInfo && applicationDetails.companyInfo.companyName}
          </Typography>
        </Grid>

        <Grid item md={5}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            City:
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            {applicationDetails && applicationDetails.companyInfo && applicationDetails.companyInfo.city}
          </Typography>
        </Grid>

        <Grid item md={5}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            Location:
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            {applicationDetails && applicationDetails.companyInfo && applicationDetails.companyInfo.location}
            {/* {jsonObject.location_name} */}
          </Typography>
        </Grid>

        <Grid item md={5}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            PAN:
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            {applicationDetails && applicationDetails.companyInfo && applicationDetails.companyInfo.pan}
          </Typography>
        </Grid>

        <Grid item md={5}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            Operating Since:
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            {applicationDetails && applicationDetails.companyInfo && moment(applicationDetails.companyInfo.operatingSince).format("DD-MM-YYYY")}
          </Typography>
        </Grid>

        <Grid item md={5}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            Operating As:
          </Typography>
        </Grid>
        <Grid item md={7}>
          <Typography fontSize={'16px'} variant="h6" gutterBottom>
            {applicationDetails && applicationDetails.companyInfo && applicationDetails.companyInfo.operatingAs}
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default Official